import React from 'react'
import GaddressFields from '../google-address';
import Input from '../reactive-input/index';
import Select from '../reactive-select/select';
import Phone from '../reactive-phone';
import OrgName from '../reactive-input/OrgName';
import AddressInput from '../reactive-input/AddressInput';

const Fields = props => {
  let cmp;
  switch (props.type) {
    case 'phone':
      cmp = <Phone {...props} />;
      break;
      case 'gAddress':
        cmp = <GaddressFields {...props} />;
        break;
      case 'select':
        cmp = <Select key={props.name} {...props} />
        break;
      case 'org-name':
        cmp = <OrgName {...props} />
        break;
      case 'address':
        cmp = <AddressInput {...props} />
        break;
    default:
      cmp = <Input {...props} />;
      break;
  }
  return cmp;
};

export default Fields;